import React from 'react';
import './Header.css'

const Header = () => {
    return (
    <section className='header-section'>
        <h2 className='header-text'>React Reducer Quiz App</h2>
    </section>
    );
};

export default Header;